"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringMap_1 = require("./StringMap");
function getStrictValues(map) {
    return StringMap_1.getKeys(map).map(function (key) { return map[key]; });
}
exports.getStrictValues = getStrictValues;
function withDefault(f, t, map, key) {
    var value = map[key];
    return value !== undefined ? f(value) : t;
}
exports.withDefault = withDefault;
//# sourceMappingURL=StrictStringMap.js.map